import axios from "src/utils/axios";

class MgmtSections {

  createSection = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .post("/api/catalog/product/section", payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  getSections = (customerId) =>
    new Promise((resolve, reject) => {
      axios
        .get(`/api/catalog/product/section?customerId=${customerId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteSection = (sectionId) =>
    new Promise((resolve, reject) => {
      axios
        .delete(`/api/catalog/product/section?sectionId=${sectionId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const mgmtSections = new MgmtSections();

export default mgmtSections;